/** Prefix for course-schedule class row anchors (`#class-{id}`). */
export const CLASS_INSTANCE_HASH_PREFIX = "class-";

/**
 * DOM id for a class instance row in the schedule list.
 */
export function getClassInstanceElementId(classInstanceId: string): string {
	return `${CLASS_INSTANCE_HASH_PREFIX}${classInstanceId}`;
}

/**
 * Whether a location hash (without `#`) targets a schedule class row.
 */
export function isClassInstanceHash(hash: string): boolean {
	return (
		hash.startsWith(CLASS_INSTANCE_HASH_PREFIX) &&
		hash.length > CLASS_INSTANCE_HASH_PREFIX.length
	);
}

/**
 * Smooth-scroll to a class row after the next paint so the schedule list is
 * in the DOM (schedule often loads after the initial course page paint).
 */
export function scrollToClassInstance(elementId: string): void {
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			const element = document.getElementById(elementId);
			if (!element) {
				return;
			}

			const offsetTop = element.getBoundingClientRect().top + window.scrollY;
			window.scrollTo({top: offsetTop, behavior: "smooth"});
		});
	});
}
